import { useBaseApiQuery } from "@query/baseQuery";

export const useChallengesQuery = (page) => {
    return useBaseApiQuery(
        { endpoint: `/organization/me/challenge/page/${page}` }, 
        { queryKey: ["challenges", page] }
    );
};

export const useChallengeQuery = (challengeUuid, refetchOnWindowFocus) => {
    return useBaseApiQuery(
        { endpoint: `/challenge/${challengeUuid}` }, 
        { queryKey: ["challenge", challengeUuid], enabled: !!challengeUuid, refetchOnWindowFocus: refetchOnWindowFocus }
    );
};


export const useChallengeTypesQuery = () => {
    return useBaseApiQuery(
        { endpoint: `/challenge/types` }, 
        { queryKey: ["challenge", "types"] }
    );
};


export const useChallengeLeaderboardQuery = (challengeUuid, page) => {
    return useBaseApiQuery(
        {endpoint:`/challenge/${challengeUuid}/leaderboard/${page}`}
    )
}

export const useChallengeWinnersAndContestantsCountQuery = (challengeUuid) => {
    return useBaseApiQuery(
        { endpoint: `/challenge/${challengeUuid}/winners_and_contestants_count` },
        { queryKey: ["challenge", "winners_and_contestants_count", challengeUuid], enabled: !!challengeUuid }
    );
};

